import currency from "./slices/currency";
import shopFilter from "./slices/shopFilter";
import userCart from "./slices/userCart";
import chat from "./slices/chat";
import search from "./slices/search";
import order from "./slices/order";
import carts from "./slices/carts";
import liked from "./slices/liked";

const rootReducer = {
  liked: liked,
  filter: shopFilter,
  currency: currency,
  userCart: userCart,
  chat: chat,
  search: search,
  order: order,
  carts: carts,
};

export default rootReducer;
